var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 65,
    viewBox: "0 0 42 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 18.2079C40 20.8714 39.668 25.2149 39.0351 30.1315H2.96489C2.332 25.2149 2 20.8714 2 18.2079C2 13.4465 3.06516 9.27133 4.8052 6.35867C6.53709 3.45965 8.79046 2 11.2683 2C12.3313 2 13.51 2.53878 15.2465 3.39882C15.3037 3.42714 15.3617 3.45593 15.4205 3.4851C16.9108 4.22485 18.9018 5.21315 21 5.21315C23.0982 5.21315 25.0892 4.22485 26.5795 3.4851C26.6383 3.45593 26.6963 3.42714 26.7535 3.39882C28.49 2.53878 29.6687 2 30.7317 2C33.2095 2 35.4629 3.45965 37.1948 6.35867C38.9348 9.27133 40 13.4465 40 18.2079Z",
    fill: "white",
    stroke: "#0F2650",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2919 32.1312H29.7065V39.6286L26.6333 43.9128V59.9785L20.9992 64.2627L15.365 59.9785V43.9128L12.2919 39.6286V32.1312Z",
    fill: "#0F2650"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3172 4.28461C8.79115 4.28461 5.12207 8.12081 5.12207 12.853",
    stroke: "#D0CFCE",
    strokeWidth: 6.70258,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3657 52.481L26.634 55.6941V57.8362L15.3657 54.6231V52.481Z",
    fill: "#D8D8D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3657 48.1974L26.634 51.4106V53.5527L15.3657 50.3395V48.1974Z",
    fill: "#D8D8D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3657 43.9133L26.634 47.1265V49.2686L15.3657 46.0554V43.9133Z",
    fill: "#D8D8D8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOne);
export default __webpack_public_path__ + "static/media/serviceOne.455ea8db174d07d7139af8c0d6109f06.svg";
export { ForwardRef as ReactComponent };